// PolicyAckBootstrap — app-wide compliance bootstrap (mounted once inside the
// auth/query providers, renders nothing). Two jobs:
//  1. Record a new signup's policy acceptance server-side as soon as a session
//     exists (bridges the email-confirmation gap where there's no auth.uid() at
//     the moment of signUp). LAUNCH_READINESS F-acceptance-at-signup.
//  2. Auto-honor the Global Privacy Control (GPC) browser signal as a "Do Not
//     Sell/Share" opt-out for the signed-in user. LAUNCH_READINESS B1.
import { usePolicyAckBootstrap } from "@/hooks/usePolicyAcceptance";
import { useGpcAutoOptOut } from "@/hooks/usePrivacyOptout";

export default function PolicyAckBootstrap() {
  usePolicyAckBootstrap();
  useGpcAutoOptOut();
  return null;
}
